(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lua-product-gallery-overlay"] && !Shopify.designMode) return;
  try {
    class LuaPdpGalleryOverlay extends HTMLElement {
  connectedCallback() {
    const gallery = this.closest('.shopify-section')?.querySelector('media-gallery');
    if (gallery) gallery.appendChild(this);

    this.wishButton = this.querySelector('[data-wish]');
    this.zoomButton = this.querySelector('[data-zoom-trigger]');
    this.gallery = gallery;

    this.restoreWishlist();
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  get saved() {
    try {
      return JSON.parse(localStorage.getItem('lua:wishlist') || '[]');
    } catch (error) {
      return [];
    }
  }

  restoreWishlist() {
    if (this.wishButton && this.saved.includes(this.wishButton.dataset.wish)) {
      this.wishButton.setAttribute('aria-pressed', 'true');
    }
  }

  onClick = (event) => {
    if (event.target.closest('[data-wish]')) {
      this.toggleWish();
    } else if (event.target.closest('[data-zoom-trigger]')) {
      this.triggerZoom();
    }
  };

  toggleWish() {
    const id = this.wishButton.dataset.wish;
    const saved = this.saved;
    const next = saved.includes(id) ? saved.filter((item) => item !== id) : saved.concat(id);

    this.wishButton.setAttribute('aria-pressed', String(next.includes(id)));

    try {
      localStorage.setItem('lua:wishlist', JSON.stringify(next));
    } catch (error) {
      // Storage unavailable (private mode); the visual state still toggles.
    }
  }

  triggerZoom() {
    const activeSlide = this.gallery?.querySelector('slideshow-slide:not([hidden])') || this.gallery?.querySelector('slideshow-slide');
    activeSlide?.click();
  }
}

if (!customElements.get('lua-pdp-gallery-overlay')) {
  customElements.define('lua-pdp-gallery-overlay', LuaPdpGalleryOverlay);
}
  } catch(e) { console.error(e); }
})();

})();
